export default __webpack_public_path__ + "static/media/crossroadsbuypic.23d52c6e.jpeg";